import { connect } from 'react-redux'
import TermsAndConditions from './terms-and-conditions'
import { acceptTc } from './redux/terms-and-conditions.actions'
import { withMe } from 'pobble-components/dist/pobble-user'
import { getAcceptTCRequest } from './redux/terms-and-conditions.selectors'

const mapStateToProps = (state, { meRequest }) => {
  const acceptTCRequest = getAcceptTCRequest(state)
  return {
    pending: acceptTCRequest.pending || meRequest.pending
  }
}

const mapDispatchToProps = (dispatch, { refetchMe }) => ({
  onAccept: () => dispatch(acceptTc()).then(refetchMe)
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TermsAndConditions)
)
